import React from "react";
import { useEffect } from "react";
import { Box, Typography, Grid, useMediaQuery, useTheme } from "@mui/material";
import AppHeader from "../../../components/Dashboard/AppHeader";
import FormInput from "../../../components/Form/FormInput";
import FormDropdown from "../../../components/Form/FormDropdown";
import FormButton from "../../../components/Form/FormButton";
import { Form, Spin } from "antd";
import userStore from '../../../zustand/store/userStore';
import { ToastContainer, toast } from 'react-toastify';

const TeacherRegistration = () => {
    const [showPassword, setShowPassword] = React.useState(false);
    const handleClickShowPassword = () => setShowPassword((show) => !show);

    const courses = [
        { label: 'Chemistry', value: 'Chemistry' },
        { label: 'Physics', value: 'Physics' },
        { label: 'Math', value: 'Math' },
    ];


    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const { data, authToken, userSignup, message, error, loading } = userStore();


    // useEffect(() => {
    //     if (message) {
    //         toast.success(`'Sign Up successfull': ${message}`);
    //         Form.resetFields(); 
    //     }
    //     if (error) {
    //         toast.error(error);
    //     }
    // }, [message, error])

    const onFinish = async (values) => {
        const payload = { ...values, role: 'teacher' };
        await userSignup(payload);
    };

    return (
        <>
            <AppHeader
                title={'Teacher Registration'}
                content={
                    'Purpose: Display performance reports of all students for evaluation purposes.'
                }
            />
            <Typography variant="h5" fontWeight="bold" mb={-3}>Register Teacher</Typography>
            <Box
                sx={{
                    width: isMobile ? "100%" : "69%",  // Adjust width for mobile
                    height: "auto",
                    mt: 5,
                    p: 3,
                    border: "2px solid black",
                    borderRadius: 2,
                    boxShadow: "2px 2px 10px rgba(0,0,0,0.1)"
                }}
            >
                <Form
                    name="signup"
                    onFinish={onFinish}
                >
                    <Grid container spacing={2}> {/* Use larger spacing on mobile for readability */}
                        <Grid item xs={12} md={6}>
                            <Typography sx={{ mb: 1 }}>Full Name</Typography>
                            <FormInput name="fullName" placeholder="Enter your full name" type="text" width="100%" />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Typography sx={{ mb: 1 }}>Email</Typography>
                            <FormInput name="email" placeholder="Enter your email" type="email" width="100%" />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Typography sx={{ mb: 1 }}>Password</Typography>
                            <FormInput name="password" placeholder="Enter your password" type="password" width="100%" />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Typography sx={{ mb: 1 }}>Subject Expertise</Typography>
                            <FormDropdown
                                name="courseName"
                                placeholder="Select Course"
                                options={courses}
                            />
                        </Grid>
                    </Grid>
                    <Box mt={2} display="flex" flexDirection={isMobile ? "column" : "row"} justifyContent="start" gap={2}>
                        <FormButton
                            text= {loading ? <Spin /> : "Save Teacher"}
                            backgroundColor="#22C55E"
                            borderColor="black"
                            width={isMobile ? "100%" : "auto"}  // Ensure button width scales for mobile
                        />
                        <FormButton
                            text="Reset"
                            backgroundColor="white"
                            borderColor="black"
                            width={isMobile ? "100%" : "auto"}  // Ensure button width scales for mobile
                        />
                    </Box>
                </Form>
            </Box>
            <ToastContainer />
        </>
    );
};

export default TeacherRegistration;
